export default __webpack_public_path__ + "static/media/news3.1e871927.webp";